// extracted by mini-css-extract-plugin
export default {"container":"GraphTabs_container__kvb1G","header":"GraphTabs_header__mql4f","triggers":"GraphTabs_triggers__5E5IA","content":"GraphTabs_content__vWwLP"};